export const SERVICES_MAIN_PATH = '/uslugi/';

export const SERVICES_MAIN_LANDING_NAME = 'services-main';

export const SERVICES_MAIN_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/services-main';
